module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<tr data-index=\"")
    ; __append(escapeFn( index ))
    ; __append("\" on-click=\"onItemClick\">\n	<td>\n		")
    ; __append(escapeFn( Date.fromPG(item.createddatetime).format() ))
    ; __append(" / ")
    ; __append(escapeFn( Date.fromTZ(item.datetime).format() ))
    ; __append("\n	</td>\n\n	<td>\n		")
    ; __append(escapeFn( GIS.dmsString(item.lat) ))
    ; __append(" / ")
    ; __append(escapeFn( GIS.dmsString(item.lon) ))
    ; __append("\n	</td>\n\n	<td>\n		")
    ; 
		var run = item.run ? Math.round(item.run) : 0;
		var duration = item.duration ? item.duration : 0;
		
    ; __append("\n		")
    ; __append(escapeFn( run ))
    ; __append(" м / ")
    ; __append(escapeFn( duration ))
    ; __append(" c\n	</td>\n\n	<td>\n		")
    ; __append(escapeFn( item.course ))
    ; __append(" / ")
    ; __append(escapeFn( item.speed ))
    ; __append(" км/ч\n	</td>\n\n	<td>\n		")
    ; __append(escapeFn( item.satsglonass ))
    ; __append(" / ")
    ; __append(escapeFn( item.satsgps ))
    ; __append("\n	</td>\n</tr>\n")
  }
  return __output.join("");

}